import axios from "axios";
import authHeader from "./auth-header";

import { API_URL } from "./constants";

class MaterialStockService {

   addEditMaterial(data){
      return axios.post(`${API_URL}material-stocks/create-material-record`, data,  {
        headers: authHeader(),
      })
   }

   fetchMaterialUnits(){
      return axios.get(`${API_URL}material-stocks/fetch-material-units`, {
        headers: authHeader(),
      })
   }

   fetchAllMaterialTypes(){
      return axios.get(`${API_URL}material-stocks/fetch-all-material-types`, {
        headers: authHeader(),
      })
   }

   fetchAllMaterials(){
      return axios.get(`${API_URL}material-stocks/fetch-all-materials`, {
        headers: authHeader(),
      })
   }

   updateActiveState(id, data){
      return axios.post(`${API_URL}material-stocks/update-active-state/${id}`, data,  {
         headers: authHeader(),
       })
   }

   deleteMaterialItem(id){
      return axios.delete(`${API_URL}material-stocks/delete-material-item/${id}`, {
         headers: authHeader(),
       })
   }

   getPlusSetStockRecords(data){
      return axios.post(`${API_URL}material-stocks/get-plus-set-stock-records`, data, {
         headers: authHeader(),
       })
   }

   updateSingleStockValue(data, id){
       return axios.put(`${API_URL}material-stocks/update-single-value/${id}`, data, {
         headers: authHeader(),
       })
   }

   getLastClosingValue(data){
      return axios.post(`${API_URL}material-stocks/get-last-closing-value`, data, {
         headers: authHeader(),
       })
   }

}

export default new MaterialStockService();